import { api } from '../config/api';

export const employeeService = {
  getAll: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.role) params.append('role', filters.role);
    if (filters.status) params.append('status', filters.status);
    if (filters.department) params.append('department', filters.department);
    
    const queryString = params.toString();
    return api.get(`/api/employees${queryString ? `?${queryString}` : ''}`);
  },
  
  getById: async (id) => {
    return api.get(`/api/employees/${id}`);
  },
  
  create: async (data) => {
    return api.post('/api/employees', data);
  },
  
  update: async (id, data) => {
    return api.put(`/api/employees/${id}`, data);
  },
  
  delete: async (id) => {
    return api.delete(`/api/employees/${id}`);
  },
  
  getDrivers: async () => {
    return api.get('/api/employees/drivers/available');
  },
  
  getSchedule: async (id) => {
    return api.get(`/api/employees/${id}/schedule`);
  }
};
